svg {
  fill: currentColor;
  height: 100%;
  shape-rendering: geometricprecision;
  stroke: currentColor;
  stroke-width: 1.5px;
  width: 100%;
}
